import { render } from "./folioCliente.vue?vue&type=template&id=a38a70e8"
import script from "./folioCliente.vue?vue&type=script&lang=js"
export * from "./folioCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__